import { MdHelpOutline, MdOutlineQuestionAnswer } from 'react-icons/md';

const faqData = [
    {
        category: "Questions sur l'inscription et le compte",
        questions: [
            {
                q: 'Comment créer un compte vendeur sur la plateforme ?',
                a: 'Pour créer un compte vendeur, il vous suffit de remplir vos coordonnées bancaires et de compléter le processus KYC (Know Your Customer). Cela permettra de valider votre compte et de commencer à vendre des leads.',
            },
            {
                q: 'Quels documents sont nécessaires pour valider mon compte vendeur ?',
                a: 'Pour valider votre compte vendeur, vous devrez fournir vos coordonnées bancaires ainsi que compléter le processus KYC, qui peut inclure la vérification de votre identité et de votre entreprise.',
            },
            {
                q: "Y a-t-il des frais d'inscription ?",
                a: "Non, il n'y a aucun frais d'inscription pour devenir vendeur sur la plateforme.",
            },
            {
                q: 'Comment modifier mes informations de compte (email, coordonnées bancaires, etc.) ?',
                a: 'Vous pouvez modifier vos informations dans la section "Mon compte" de votre espace personnel.',
            },
        ],
    },
    {
        category: 'Questions sur la vente de leads',
        questions: [
            {
                q: 'Comment puis-je proposer mes services ou produits sur la plateforme ?',
                a: 'Pour proposer vos services ou produits, il vous suffit de créer de nouvelles offres de leads ou de vous positionner sur des offres existantes.',
            },
            {
                q: 'Quelles informations dois-je fournir pour créer une offre de vente de leads ?',
                a: 'Lorsque vous créez une nouvelle offre, vous devrez fournir des informations détaillées sur les leads que vous vendez, y compris les critères de ciblage et le prix. Cela permettra aux acheteurs de mieux comprendre ce que vous proposez.',
            },
            {
                q: 'Comment déterminer le prix de mes leads ?',
                a: 'Le prix des leads est entièrement à la discrétion du vendeur. Cependant, vous pouvez consulter la section "Benchmark" pour vous informer des prix pratiqués par d\'autres vendeurs sur la plateforme et ainsi ajuster vos tarifs en conséquence.',
            },
            {
                q: 'Quelle est la quantité minimale ou maximale de leads que je peux vendre ?',
                a: 'Pour chaque offre, la quantité minimale de leads que vous pouvez vendre est de 50, tandis que la quantité maximale est de 500.',
            },
            {
                q: 'Puis-je vendre des leads provenant de sources externes ou uniquement de ma propre base de données ?',
                a: "Les leads doivent provenir de vos propres sources ou bases de données. Les sources externes sont acceptées à condition qu'elles respectent les critères de qualité de la plateforme.",
            },
            {
                q: 'Quelles garanties de qualité suis-je censé offrir sur les leads que je vends ?',
                a: 'Il est de votre responsabilité de garantir la qualité et la conformité des leads que vous vendez. La plateforme peut prendre des mesures en cas de plaintes sur la qualité des leads.',
            },
            {
                q: 'Est-ce que je peux segmenter les leads en fonction de critères spécifiques ?',
                a: 'Oui, vous pouvez segmenter vos leads selon des critères spécifiques pour mieux cibler vos acheteurs et maximiser les ventes.',
            },
        ],
    },
    {
        category: "Questions sur l'intégration et la gestion des leads",
        questions: [
            {
                q: 'Comment intégrer mes leads à la plateforme ?',
                a: "L'intégration de vos leads à la plateforme se fait de deux manières : soit via votre landing page, soit via un Google Sheet où vous pouvez facilement importer vos leads.",
            },
            {
                q: "Est-ce que la plateforme offre des outils pour automatiser l'envoi des leads ?",
                a: "Oui, la plateforme automatise l'ensemble des envois de leads, vous permettant ainsi de gagner du temps et de simplifier la gestion de vos transactions.",
            },
            {
                q: 'Puis-je connecter mes outils CRM ou de gestion des leads à la plateforme ?',
                a: "Actuellement, l'intégration se fait via une landing page ou un Google Sheet, mais la possibilité de connecter directement un CRM n’est pas mentionnée. Pour plus d'informations, contactez notre support.",
            },
            {
                q: 'Est-ce que je reçois des notifications lorsque mes leads sont achetés ?',
                a: "Oui, à chaque fois qu'un lead est acheté sur la plateforme, vous recevez une notification dans votre espace personnel pour vous informer de la vente.",
            },
            {
                q: 'Comment puis-je suivre l’état des leads que j’ai vendus ?',
                a: 'Dans la section "Leads" de votre espace vendeur, vous pouvez suivre l\'évolution de tous les leads que vous avez vendus. Vous y trouverez des informations détaillées sur leur statut et leur traitement.',
            },
        ],
    },
    {
        category: 'Questions sur les paiements et commissions',
        questions: [
            {
                q: 'Comment fonctionne le système de paiement sur la plateforme ?',
                a: 'Le système de paiement fonctionne de la manière suivante : à partir du début de votre mission, vous devez attendre 10 jours ouvrés avant de recevoir votre premier paiement. Une fois ce délai passé, vous serez payé tous les jours, au coût unitaire par lead que vous envoyez.',
            },
            {
                q: 'Quels sont les modes de paiement acceptés pour les transactions ?',
                a: 'Les modes de paiement acceptés sont le virement bancaire et la carte bancaire (CB).',
            },
            {
                q: 'Quand et comment serai-je payé pour les leads que je vends ?',
                a: 'Vous serez payé automatiquement tous les jours pour les leads que vous avez envoyés, à compter de la fin du délai de 10 jours ouvrés après le début de votre mission.',
            },
            {
                q: 'Y a-t-il un seuil de paiement minimum à atteindre avant de recevoir mes fonds ?',
                a: "Il n'est pas mentionné de seuil minimum pour recevoir vos paiements. Cependant, les paiements sont effectués sur une base quotidienne, au coût unitaire par lead.",
            },
            {
                q: 'Quels frais sont associés aux paiements ou aux ventes de leads ?',
                a: "Il n'est pas mentionné de frais spécifiques associés aux paiements ou aux ventes de leads. Vous recevrez votre paiement net, selon les conditions convenues.",
            },
        ],
    },
    {
        category: 'Questions sur la protection et la sécurité',
        questions: [
            {
                q: 'Comment la plateforme protège-t-elle les données personnelles des leads ?',
                a: 'La plateforme respecte les normes de sécurité et de protection des données en vigueur. Toutes les données des leads sont traitées conformément à la réglementation applicable. Cependant, la responsabilité de la collecte et du traitement des données personnelles repose entièrement sur le vendeur. Tous les vendeurs doivent être conformes à la législation européenne, notamment en ce qui concerne la collecte des leads et le respect du Règlement Général sur la Protection des Données (RGPD).',
            },
            {
                q: 'Que faire si je suspecte une fraude concernant l’achat ou la vente de leads ?',
                a: 'Si vous suspectez une fraude, nous vous conseillons de contacter immédiatement le support client pour résoudre la situation.',
            },
            {
                q: 'La plateforme offre-t-elle des garanties en cas de litiges avec des acheteurs de leads ?',
                a: "En cas de litige avec la vente de leads, nous vous invitons à contacter notre support pour qu'ils interviennent et trouvent une solution adéquate dans les plus brefs délais.",
            },
            {
                q: 'Comment puis-je protéger mes informations personnelles et financières sur la plateforme ?',
                a: 'La plateforme utilise des protocoles de sécurité pour protéger vos informations personnelles et financières. Assurez-vous de toujours mettre à jour vos mots de passe et de ne pas partager vos informations sensibles avec des tiers.',
            },
            {
                q: 'Quelles sont les obligations légales pour vendre des leads sur cette plateforme ?',
                a: 'La plateforme respecte les lois sur la protection des données. Aucune information n’est collectée ou stockée sur la plateforme. Il appartient aux vendeurs d’être en conformité avec la législation. Nous garantissons exclusivement la validité du lead.',
            },
            {
                q: 'Y a-t-il des restrictions sur les types de leads que je peux vendre ?',
                a: 'Il n’y a aucune restriction. Cependant, nous invitons les vendeurs et les acheteurs à respecter la législation en vigueur que ce soit sur les données et le respect des lois européennes ou concernant le démarchage abusif. Leadrs n’est en rien responsable des relations commerciales entre le client et la société acheteuse de leads. Nous nous réservons le droit de supprimer un utilisateur en cas de manquement à une obligation légale ou tout manquement aux valeurs que nous véhiculons.',
            },
        ],
    },
    {
        category: 'Questions sur les retours et réclamations',
        questions: [
            {
                q: 'Que faire si un lead que j’ai vendu est refusé par un acheteur ?',
                a: "Si un lead que vous avez vendu est refusé par un acheteur, nous vous encourageons à discuter avec l'acheteur pour résoudre le problème. Si nécessaire, vous pouvez contacter le support de la plateforme pour obtenir de l’aide.",
            },
            {
                q: 'Existe-t-il une politique de retour ou de remboursement des leads ?',
                a: "Il n'est pas mentionné de politique spécifique de retour ou de remboursement. Cependant, en cas de problème, le support pourra intervenir pour trouver une solution.",
            },
            {
                q: 'Comment puis-je contester une vente de lead ou une réclamation d’acheteur ?',
                a: 'En cas de désaccord avec une réclamation d’acheteur, contactez notre support qui pourra analyser la situation et proposer une résolution équitable.',
            },
        ],
    },
    {
        category: 'Questions sur la performance et les statistiques',
        questions: [
            {
                q: 'Puis-je suivre la performance de mes leads sur la plateforme ?',
                a: "Oui, en tant que vendeur, vous pouvez suivre la performance de vos leads directement depuis votre tableau de bord. Vous y trouverez des statistiques détaillées, telles que le nombre de leads achetés, le taux de conversion, et d'autres données clés qui vous permettent de mesurer l'efficacité de vos leads et d'optimiser vos ventes.",
            },
            {
                q: 'La plateforme fournit-elle des rapports sur la vente de mes leads ?',
                a: 'Oui, la plateforme fournit des rapports complets sur la vente de vos leads. Vous pouvez accéder à des rapports détaillés concernant vos ventes, le montant généré, ainsi que des données de performance pour chaque lead. Ces rapports vous permettent de suivre vos performances et d’ajuster votre stratégie de vente en conséquence.',
            },
            {
                q: 'Comment savoir combien de leads j’ai vendus et combien j’ai généré en revenus ?',
                a: "Vous pouvez consulter le nombre de leads que vous avez vendus et les revenus générés directement sur votre tableau de bord vendeur. La plateforme met à jour ces informations en temps réel, vous permettant de suivre facilement vos ventes et de voir l'impact financier de vos efforts.",
            },
            {
                q: 'Existe-t-il des outils d’analyse pour optimiser la qualité des leads que je vends ?',
                a: "Oui, la plateforme propose des outils d'analyse pour vous aider à optimiser la qualité des leads que vous vendez. Ces outils vous permettent d'examiner les caractéristiques de vos leads, d'analyser les taux de conversion et de mieux comprendre les tendances de marché. Grâce à ces informations, vous pouvez ajuster vos stratégies de collecte et améliorer la qualité de vos leads afin d'augmenter vos ventes.",
            },
        ],
    },
    {
        category: 'Questions sur le support et l’assistance',
        questions: [
            {
                q: 'Que faire si j’ai un problème technique avec la plateforme ?',
                a: "Si vous rencontrez un problème technique avec la plateforme, nous vous recommandons de consulter d'abord notre guide d'assistance en ligne. Si le problème persiste, vous pouvez contacter notre support technique via le formulaire de contact ou par e-mail. Notre équipe technique s'efforcera de résoudre votre problème dans les plus brefs délais.",
            },
            {
                q: 'Comment contacter le support client ?',
                a: 'Vous pouvez contacter le support client en envoyant un e-mail à l’adresse leo@leadrs.co dédiée ou en utilisant notre formulaire de contact disponible directement sur la plateforme. Nous nous engageons à répondre à toutes les demandes dans un délai de 48 heures.',
            },
            {
                q: 'Y a-t-il un service d’assistance dédié pour les vendeurs de leads ?',
                a: "Oui, nous avons un service d'assistance dédié spécifiquement pour les vendeurs de leads. Si vous avez des questions concernant la vente de vos leads, la gestion de votre compte vendeur ou des problèmes relatifs à vos offres, vous pouvez contacter notre équipe via un support spécifique.",
            },
        ],
    },
    {
        category: 'Questions sur les conditions générales',
        questions: [
            {
                q: 'Quelles sont les conditions générales de vente de leads sur cette plateforme ?',
                a: "Les conditions générales de vente de leads sur la plateforme sont détaillées dans un document accessible à tous les utilisateurs, incluant les vendeurs. Elles régissent les règles de vente, les droits et obligations des deux parties, les modalités de paiement, de livraison des leads, ainsi que la politique de confidentialité et de protection des données. Vous pouvez consulter ce document directement dans votre espace personnel sous la section 'Conditions Générales'.",
            },
            {
                q: 'Comment la plateforme gère-t-elle la protection des acheteurs et des vendeurs ?',
                a: 'La plateforme protège les acheteurs et les vendeurs en mettant en place des mesures de sécurité robustes pour garantir la confidentialité et l’intégrité des transactions. Nous assurons également que les leads sont conformes aux réglementations en vigueur, notamment le RGPD pour les acheteurs en Europe. Pour les vendeurs, nous offrons un environnement sécurisé pour la mise en ligne et la vente de leurs leads, avec un suivi constant de la qualité des informations échangées.',
            },
            {
                q: 'Est-ce que je peux vendre des leads exclusifs ou non-exclusifs sur la plateforme ?',
                a: 'Non, sur la plateforme, vous pouvez vendre des leads uniquement à un acheteur. Si nous soupçonnons un vendeur ne respectant pas cette règle, nous nous réservons le droit de le bannir de la plateforme.',
            },
        ],
    },
    {
        category: 'Questions sur la concurrence et le marché',
        questions: [
            {
                q: 'Comment puis-je me différencier des autres vendeurs sur la plateforme ?',
                a: 'Pour vous différencier des autres vendeurs, il est important de proposer des leads de haute qualité, de bien définir vos critères de sélection, et de vous assurer que vos offres sont bien visibles.',
            },
            {
                q: 'La plateforme impose-t-elle un prix de vente minimum ou maximum pour les leads ?',
                a: 'La plateforme ne fixe pas de prix minimum ou maximum pour la vente des leads. Cependant, elle vous encourage à définir un prix compétitif en fonction de la qualité de vos leads et des tendances du marché. Il est essentiel de rester compétitif tout en garantissant la valeur de vos données. Les prix peuvent aussi être influencés par la demande pour certains types de leads.',
            },
        ],
    },
];

const SellerFaqPage = () => {
    return (
        <div className="mx-auto w-full max-w-6xl px-1 pb-6">
            <div className="w-full rounded-xl border border-leadrs-stroke bg-white px-6 py-6">
                <div className="flex items-start gap-3">
                    <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-leadrs-yellow-soft">
                        <MdHelpOutline className="h-5 w-5 text-leadrs-yellow-focus" />
                    </div>
                    <div>
                        <h1 className="font-crimson text-2xl font-semibold leading-tight text-leadrs-text md:text-3xl">
                            Foire Aux Questions
                        </h1>
                        <p className="mt-1 font-geist text-sm text-leadrs-text-soft">
                            Retrouvez toutes les reponses utiles pour votre activite vendeur et la gestion de vos leads.
                        </p>
                    </div>
                </div>
            </div>

            <div className="mt-5 space-y-5">
                {faqData.map((section, idx) => (
                    <div key={idx} className="rounded-xl border border-leadrs-stroke bg-white px-5 py-5">
                        <div className="mb-4 flex items-center gap-3 border-b border-leadrs-stroke pb-3">
                            <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-leadrs-brown-soft">
                                <MdOutlineQuestionAnswer className="h-4 w-4 text-leadrs-brown-focus" />
                            </div>
                            <h2 className="font-geist text-lg font-semibold text-leadrs-text md:text-xl">
                                {section.category}
                            </h2>
                            <span className="ml-auto rounded-full bg-leadrs-bg px-2.5 py-1 font-geist text-xs font-medium text-leadrs-text-soft">
                                {section.questions.length} questions
                            </span>
                        </div>

                        <div className="space-y-3">
                            {section.questions.map((item, qIdx) => (
                                <details
                                    key={qIdx}
                                    className="group rounded-xl border border-leadrs-stroke bg-leadrs-bg px-4 py-3 transition-colors hover:border-leadrs-text-soft"
                                >
                                    <summary className="cursor-pointer list-none pr-4 font-geist text-sm font-semibold text-leadrs-text md:text-base">
                                        <div className="flex items-center justify-between gap-3">
                                            <span>{item.q}</span>
                                            <span className="text-leadrs-text-soft transition-transform group-open:rotate-45">
                                                +
                                            </span>
                                        </div>
                                    </summary>
                                    <p className="mt-2 font-geist text-sm leading-relaxed text-leadrs-text-soft md:text-[15px]">
                                        {item.a}
                                    </p>
                                </details>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SellerFaqPage;
